import "./ContactYou.scss"
import { InputWithIcon, PhoneInput, TextTag as Text } from "../../atoms"
import {
  CONTACT_YOU_EMAIL_PLACEHOLDER,
  CONTACT_YOU_PHONE_LABEL,
  INVALID_FLAG_SELECTED,
  INVALID_MOBILE,
  OTP_LABEL,
  OTP_RESEND_MSG,
  RESEND_AGAIN,
} from "../../constants/messages"
import { Form, Row } from "antd"
import React, { useState, useRef } from "react"
import {
  emailVerification,
  getUserData,
  sendOtpToMobile,
  verifyMobile,
} from "../../redux/actionCreators/auth"

import { ContactYouValidation } from "../../validationSchema/ContactYouValidation"
import { OTP_VERIFY_FAILED } from "../../constants/notificationMsg"
import { OtpInput } from "../../molecules/OtpInput"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import { withFormik } from "formik"
import { withRouter } from "react-router-dom"

import EditImg from "../../assets/images/icon-edit.png"
import SaveImg from "../../assets/images/icon-tick.svg"

const S = props => {
  const {
    values,
    mobileVerificationFailed,
    handleChange,
    handleSubmit,
    handleBlur,
    touched,
    errors,
    setErrors,
    user,
  } = props

  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [otpError, setOtpError] = useState(false)
  const reg = new RegExp("[-() ]", "g")

  const [isPhoneEditable, setIsPhoneEditable] = useState(false)
  const [isEmailEditable, setIsEmailEditable] = useState(false)
  const [isOtpFieldVisible, setIsOtpFieldVisible] = useState(false)
  const [showEmailCheckOutlined, setShowEmailCheckOutlined] = useState(false)
  const [showContactCheckOutlined, setShowContactCheckOutlined] = useState(
    false
  )
  const [prevOtp, setPrevOtp] = useState()
  const [mobileNumber, setMobileNumber] = useState(
    _.get(props.user, "phone_number", "")
  )
  const isPrimaryEmailValidated =
    _.get(user, "signup_method") === "EMAIL" &&
    _.get(user, "email_verification_status")

  const isPrimaryPhoneValidated =
    _.get(user, "signup_method") === "PHONE" &&
    _.get(user, "phone_number_verification_status")

  const otpRef = useRef()
  const inputRef = useRef()
  const [emailInputRef, setInputRef] = useState(inputRef)

  React.useEffect(() => {
    if (mobileVerificationFailed) {
      setOtpError(mobileVerificationFailed)
    }
  }, [mobileVerificationFailed])

  //clear entered otp values
  const clearInput = () => {
    if (otpRef.current) otpRef.current.clearInputValues()
  }

  const sendOtp = async () => {
    values.mobile = mobileNumber
    if (!values.mobile) {
      setError(true)
      setErrorMsg(INVALID_MOBILE)
    }
    if (values.mobile && !error) {
      props
        .sendOtpToMobile(values, () => setIsOtpFieldVisible(true))
        .then(response => {
          //add error message when user tries to add an existing phone number as sec contact
          if (_.get(response, "status") === 400) {
            setError(true)
            setErrorMsg(response.data.error)
          }
          clearInput()
        })
    }
  }

  //verify the otp entered
  const verifyOtp = otpValue => {
    if (otpValue === prevOtp && mobileVerificationFailed) {
      setOtpError(true)
    }
    props
      .verifyMobile({ mobile: mobileNumber, otp: otpValue }, () => {
        setIsOtpFieldVisible(false)
        setShowContactCheckOutlined(false)
        setIsPhoneEditable(false)
      })
      .then(response => {
        clearInput()
      })
    setPrevOtp(otpValue)
  }

  const verifyAndSaveEmail = () => {
    if (values.email) {
      props
        .emailVerification(localStorage.getItem("token"), values.email)
        .then(response => {
          //add error message when user tries to add an existing email id as sec contact
          if (_.get(response, "status") === 403) {
            setErrors({ email: response.data.error })
          } else {
            props.getUserData(props.user.id)
            setShowEmailCheckOutlined(false)
            setIsEmailEditable(false)
          }
        })
    }
  }
  const addReadonlyClass = isPhoneEditable => {
    if (isPhoneEditable) return ""
    return "form-control-readonly"
  }

  const renderOTPVerificationStatusText = () => {
    if (otpError && mobileVerificationFailed) {
      return (
        <Text textType="smallTextSecondary" className="info-error">
          {OTP_VERIFY_FAILED}
        </Text>
      )
    } else {
      return ""
    }
  }

  const onChangeOTP = () => setOtpError(false)

  return (
    <div id="ContactYou">
      <form name="contactYouTab" onSubmit={handleSubmit}>
        <Row id="contactYouInputs">
          <Form.Item
            validateStatus={touched.email && errors.email ? "error" : undefined}
          >
            <InputWithIcon
              name="email"
              placeholder={CONTACT_YOU_EMAIL_PLACEHOLDER}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="off"
              error={touched.email && errors.email ? errors.email : ""}
              icon={
                isPrimaryEmailValidated
                  ? "none"
                  : !showEmailCheckOutlined
                  ? "edit"
                  : "saved"
              }
              parentref={setInputRef}
              onIconClick={() => {
                emailInputRef.focus()
                setIsEmailEditable(true)
                if (!showEmailCheckOutlined) setShowEmailCheckOutlined(true)
                if (showEmailCheckOutlined) verifyAndSaveEmail()
              }}
              readOnly={!isEmailEditable || isPrimaryEmailValidated}
            />
          </Form.Item>
          <div className="phone-input">
            <PhoneInput
              inputClassName={addReadonlyClass(isPhoneEditable)}
              autoFocus={true}
              placeholder={CONTACT_YOU_PHONE_LABEL}
              format={true}
              separateDialCode={true}
              defaultValue={mobileNumber || ""}
              numberType={"MOBILE"}
              onPhoneNumberChange={(isValid, number, data, formattedValue) => {
                setIsOtpFieldVisible(false)
                if (isValid) {
                  values.mobile = formattedValue.replace(reg, "")
                  setMobileNumber(values.mobile)
                  setError(!isValid)
                } else {
                  setError(!isValid)
                  setErrorMsg(INVALID_MOBILE)
                }
              }}
              onSelectFlag={(number, obj, formattedValue, isWrong) => {
                setIsOtpFieldVisible(false)
                if (number !== "" && !isWrong) {
                  setError(!isWrong)
                  setErrorMsg(INVALID_FLAG_SELECTED)
                } else {
                  setErrorMsg("")
                }
              }}
              icon={
                isPrimaryPhoneValidated
                  ? "none"
                  : !showContactCheckOutlined
                  ? "edit"
                  : "saved"
              }
              onIconClick={() => {
                setIsPhoneEditable(true)
                setShowContactCheckOutlined(true)
                if (showContactCheckOutlined) sendOtp()
              }}
              disabled={!isPhoneEditable || isPrimaryPhoneValidated}
              error={error && errorMsg}
            />
          </div>
        </Row>
        {isOtpFieldVisible && (
          <Row className="otp-container">
            <Text textType="sectionHeading">{OTP_LABEL}</Text>
            <Form.Item
              validateStatus={touched.otp && errors.otp ? "error" : undefined}
            >
              <OtpInput
                otpLength={4}
                onOtpSubmit={verifyOtp}
                ref={otpRef}
                onChange={onChangeOTP}
              ></OtpInput>
            </Form.Item>
            {renderOTPVerificationStatusText()}
            <Text textType="sectionTextPrimary">
              {OTP_RESEND_MSG}
              <a className="resend-otp-btn" onClick={sendOtp}>
                {RESEND_AGAIN}
              </a>
            </Text>
          </Row>
        )}
      </form>
    </div>
  )
}

const ContactYou = withFormik({
  enableReinitialize: true,
  validationSchema: ContactYouValidation,
  mapPropsToValues: props => ({
    email: _.get(props.user, "email", ""),
    mobile: _.get(props.user, "phone_number", ""),
    otp: "",
  }),
})(S)

const mapStateToProps = state => ({
  user: state.auth.user,
  partnerDetails: _.get(state, "invitePeople.partnerDetails", {}),
  mobileVerificationFailed: _.get(state.auth, "mobileVerificationFailed"),
})

export default connect(mapStateToProps, {
  sendOtpToMobile,
  emailVerification,
  getUserData,
  verifyMobile,
})(withRouter(ContactYou))
